import type { CheckoutFlow } from './checkout-events';

/**
 * The three economically different ways to pay, sent to Meta as the custom-data
 * parameter `payment_type` on InitiateCheckout, AddPaymentInfo, Subscribe and
 * Purchase — the owner builds one custom conversion (and campaign) per value,
 * while the general events keep firing exactly as before.
 *
 *   `annual`        any yearly plan, however it is paid;
 *   `subscription`  a monthly plan through the card-on-file sheet (Payme card
 *                   form or Octobank) — the auto-renewal flow;
 *   `onetime`       any other monthly payment (the «Оплатить разово» sheet and
 *                   its hosted Payme/Click page, an invoice, the SMS invoice).
 *
 * ⚠️ The API derives the same three values on its side (`paymentType` in
 * `services/api/src/modules/meta/payment-event.ts`), and the two must agree: a
 * deduplicated Pixel/CAPI pair keeps only ONE leg's custom_data, so a leg that
 * says something else is a coin toss over which answer Meta ends up with. That
 * is why each caller derives the value ONCE and hands the same string to the
 * Pixel (`tracking.ts`) and to the CAPI bridge (`sendMetaEvent`) — and why the
 * Subscribe/Purchase leg does not call this at all but echoes the server's
 * answer from `GET /billing/conversion`.
 *
 * `billingPeriod` is the plan row's (`'monthly'` | `'annual'`); `flow` is the
 * sheet that is firing, in the checkout ladder's own vocabulary.
 */
export type PaymentType = 'annual' | 'subscription' | 'onetime';

export function paymentTypeFor(billingPeriod: string, flow: CheckoutFlow): PaymentType {
  if (billingPeriod === 'annual') return 'annual';
  return flow === 'card' ? 'subscription' : 'onetime';
}
